import React, { useEffect } from 'react';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';

type SetPasswordProps = {
  userData: {
    password: string
    confirm_password: string
    first_name: string
    last_name: string
    gender: string
    date_of_birth: string | null
    place_of_birth: string
    nationality: string
    country_residence: string
    employment_title: string
    employment_type: string
    address1: string
    city: string
    state: string
    country: string
    department: string
    token: string | null
    company_id: string | null
  }
  errors: {
    password: string
    confirm_password: string
    first_name: string
    last_name: string
    gender: string
    date_of_birth: string | null
    place_of_birth: string
    nationality: string
    country_residence: string
    employment_title: string
    employment_type: string
    address1: string
    city: string
    state: string
    country: string
  }
  setErrors:(value: any) => void;
  setUserData: (value: any) => void;
  steps: string[]
  activeStep: number
  setActiveStep:(value: number) => void;
  validToken: (value: number) => void;
};

export default function SetPassword({
  userData, errors, setErrors, setUserData, steps, activeStep, setActiveStep, validToken,
} : SetPasswordProps) {
  useEffect(() => {
    if (validToken) {
      setActiveStep(1);
    }
  }, [validToken]);
  const handleNext = () => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,}$/;

    if (userData.password.trim() === '') {
      setErrors({ ...errors, password: 'This field required' });
    } else if (!passwordRegex.test(userData.password)) {
      setErrors({ 
        ...errors, 
        password: 'Password must be 8 chars with 1 uppercase, 1 lowercase, 1 number & 1 special char'
      });
    } else if (userData.confirm_password.trim() === '') {
      setErrors({ ...errors, confirm_password: 'This field required' });
    } else if (userData.password !== userData.confirm_password) {
      setErrors({ ...errors, confirm_password: 'confirm password not match password' });
    } else {
      setActiveStep(activeStep + 1);
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
  };

  const handleChange = (name: string, value: string) => {
    setErrors({ ...errors, password: '', confirm_password: '' });
    setUserData({ ...userData, [name]: value });
  };

  return (
    <>
      <Typography variant='h6' gutterBottom>
        Set Password
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <TextField
            margin='normal'
            required
            fullWidth
            name='password'
            label='Password'
            type='password'
            id='password'
            error={errors.password !== ''}
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={userData.password}
            helperText={errors.password !== '' ? errors.password : ''}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            error={errors.confirm_password !== ''}
            margin='normal'
            required
            fullWidth
            name='confirm_password'
            label='Confirm Password'
            type='password'
            id='password'
            onChange={(e) => handleChange(e.target.name, e.target.value)}
            value={userData.confirm_password}
            helperText={errors.confirm_password !== '' ? errors.confirm_password : ''}
          />
        </Grid>
      </Grid>
      {activeStep === steps.length ? (
        <Typography variant='h5' gutterBottom>
              Thank you for your submission.
        </Typography>
      ) : (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          {activeStep !== 0 && (
            <Button onClick={handleBack} sx={{ mt: 3, ml: 1 }}>
                  Back
            </Button>
          )}

          <Button
            name='next'
            variant='contained'
            onClick={handleNext}
            sx={{ mt: 3, ml: 1 }}
          >
            {activeStep === steps.length - 1 ? 'Update' : 'Next'}
          </Button>
        </Box>
      )}
    </>

  );
}
